import React from 'react'
import Loadable from 'react-loadable'
import LoadingComponent from 'components/generic/LoadingComponent'

export default Loadable({
  loader: () => import(/* webpackChunkName: "blogPost" */ './'),
  loading: () => <LoadingComponent />
})
